"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChartSettings;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdVisualize = require("cccisd-visualize");
var _excluded = ["data"],
  _excluded2 = ["data"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ChartSettings(_ref) {
  var type = _ref.type,
    name = _ref.name,
    data = _ref.data,
    showSummaryStatsToggle = _ref.showSummaryStatsToggle;
  switch (type) {
    case 'bar':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".bar"),
        component: BarSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'line':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".line"),
        component: LineSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'pie':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".pie"),
        component: PieSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'swarm':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".swarm"),
        component: SwarmSettings,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'gauge':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".gauge"),
        component: GaugeSettings,
        data: data,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    case 'bullet':
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "".concat(name, ".bullet"),
        component: BulletSettings,
        data: data,
        showSummaryStatsToggle: showSummaryStatsToggle
      });
    default:
      return /*#__PURE__*/_react["default"].createElement(DefaultSettings, {
        showSummaryStatsToggle: showSummaryStatsToggle
      });
  }
}
function BarSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bar.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function LineSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Line.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function PieSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Pie.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function SwarmSettings(props) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Swarm.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function GaugeSettings(_ref2) {
  var data = _ref2.data,
    props = _objectWithoutProperties(_ref2, _excluded);
  (0, _react.useEffect)(function () {
    var _data$, _props$field$value$ra;
    var maxValue = data ? (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.maxValue : 0;
    if (!((_props$field$value$ra = props.field.value.ranges) !== null && _props$field$value$ra !== void 0 && _props$field$value$ra.length) > 0 && maxValue) {
      props.form.setFieldValue("".concat(props.field.name, ".ranges"), [[maxValue * 0.6, '#d9534f'], [maxValue * 0.8, '#f0ad4e'], [maxValue, '#5cb85c']]);
    }
  }, [data]);
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Gauge.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function BulletSettings(_ref3) {
  var data = _ref3.data,
    props = _objectWithoutProperties(_ref3, _excluded2);
  (0, _react.useEffect)(function () {
    var _props$field$value$ra2;
    if (!data) {
      return;
    }
    var hasRanges = ((_props$field$value$ra2 = props.field.value.ranges) === null || _props$field$value$ra2 === void 0 ? void 0 : _props$field$value$ra2.length) > 0;
    var maxValue = Number(data.max) || 0;
    if (maxValue > 0 && !hasRanges) {
      props.form.setFieldValue(props.field.name, _objectSpread(_objectSpread({}, props.field.values), {}, {
        ranges: [[maxValue * 0.6, '#d9534f'], [maxValue * 0.8, '#f0ad4e'], [maxValue, '#5cb85c']]
      }));
    }
  }, [data]);
  if (!data) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bullet.Settings, props, /*#__PURE__*/_react["default"].createElement(AdditionalSettings, props));
}
function AdditionalSettings(_ref4) {
  var _form$values;
  var field = _ref4.field,
    form = _ref4.form,
    showSummaryStatsToggle = _ref4.showSummaryStatsToggle;
  return /*#__PURE__*/_react["default"].createElement("details", null, /*#__PURE__*/_react["default"].createElement("summary", null, /*#__PURE__*/_react["default"].createElement("strong", null, "Additional Settings")), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Variable Name",
    name: "showLabel",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Variable Label",
    name: "showVariableLabel",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Question",
    name: "showQuestion",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Total Responses",
    name: "showTotalResponses",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Table",
    name: "showTable",
    component: _cccisdFormik.CccisdToggle
  }), showSummaryStatsToggle && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Summary Statistics",
    name: "showSummaryStats",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Above Chart",
    name: "aboveChart",
    component: _cccisdFormik.CccisdWysiwyg
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Below Chart",
    name: "belowChart",
    component: _cccisdFormik.CccisdWysiwyg
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Chart Height",
    name: "chartHeight",
    component: _cccisdFormik.CccisdInput,
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Enable Rollup Threshold",
    name: "enableRollupThreshold",
    component: _cccisdFormik.CccisdToggle
  }), (form === null || form === void 0 ? void 0 : (_form$values = form.values) === null || _form$values === void 0 ? void 0 : _form$values.enableRollupThreshold) && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Rollup Threshold Value",
    name: "rollupThresholdValue",
    component: _cccisdFormik.CccisdInput,
    type: "number",
    min: "0"
  }));
}
function DefaultSettings() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Variable Name",
    name: "showLabel",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Variable Label",
    name: "showVariableLabel",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Question",
    name: "showQuestion",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Total Responses",
    name: "showTotalResponses",
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Above Table",
    name: "aboveChart",
    component: _cccisdFormik.CccisdWysiwyg
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Text Below Table",
    name: "belowChart",
    component: _cccisdFormik.CccisdWysiwyg
  }));
}